import React, { FunctionComponent, useMemo } from 'react';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { ResponseState } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';

export const ReplyRejected: FunctionComponent<{ reply: any }> = ({ reply }) => {
    const { t } = useTranslation('reviews2');
    const isRejected = useMemo(() => [ResponseState.Rejected].includes(reply.responseState!), [reply]);
    const isFailed = useMemo(() => [ResponseState.Failed].includes(reply.responseState!), [reply]);

    if (!isRejected && !isFailed) {
        return null;
    }

    return (
        <span className="reply-rejected">
            <OverlayTrigger
                overlay={
                    <Tooltip id={reply.document_id}>{t(isRejected ? 'REJECTED_TOOLTIP' : 'FAILED_TOOLTIP')}</Tooltip>
                }
            >
                <i className="icon-exclamation-circle" />
            </OverlayTrigger>
            {t(isRejected ? 'REPLY_REJECTED' : 'REPLY_FAILED')}{' '}
        </span>
    );
};
